module.exports = __webpack_public_path__ + "img/logo-ct.45304bf4.png";